import helper from 'store/helper';
import types from './types';

const fetchLtvDetail = () => helper.createAction(types.FETCH_LTV_DETAIL);

const fetchLtvDetailSucceeded = (data) =>
  helper.createAction(types.FETCH_LTV_DETAIL_SUCCEEDED, data);

const fetchLtvDetailFailed = (error) =>
  helper.createAction(types.FETCH_LTV_DETAIL_FAILED, { error });

const requestStart = () => helper.createAction(types.REQUEST_START);

const setLtvEvaluationPeriod = (period) =>
  helper.createAction(types.SET_LTV_EVALUATION_PERIOD, { period });

const updateSort = (field, direction) =>
  helper.createAction(types.UPDATE_SORT, { field, direction });

const updatePage = (page) =>
  helper.createAction(types.UPDATE_PAGE, { page });

const setAxis = (axis) => helper.createAction(types.SET_AXIS, { axis });

const setProductAxis = (productAxis) =>
  helper.createAction(types.SET_PRODUCT_AXIS, { productAxis });

const setDimensions = (dimensions) =>
  helper.createAction(types.SET_DIMENSIONS, { dimensions });

const setMetrics = (metrics) =>
  helper.createAction(types.SET_METRICS, { metrics });

// Filters are sourced from the shared CommonBar FilterContainer; the
// container maps them to the API key shape and forwards them through this
// action so the saga has a single source of truth at fetch time.
const setFilters = (filters) =>
  helper.createAction(types.SET_FILTERS, { filters });

// Single-shot commit from the 項目切替 modal: { axis, productAxis,
// dimensions, metrics }. Triggers a single re-fetch.
const setDisplayItems = (payload) =>
  helper.createAction(types.SET_DISPLAY_ITEMS, payload);

const hydrateDisplayItems = (payload) =>
  helper.createAction(types.HYDRATE_DISPLAY_ITEMS, payload);

const downloadCsv = () => helper.createAction(types.DOWNLOAD_CSV);

export default {
  fetchLtvDetail,
  fetchLtvDetailSucceeded,
  fetchLtvDetailFailed,
  requestStart,
  setLtvEvaluationPeriod,
  updateSort,
  updatePage,
  setAxis,
  setProductAxis,
  setDimensions,
  setMetrics,
  setFilters,
  setDisplayItems,
  hydrateDisplayItems,
  downloadCsv,
};
